// These must be the first lines in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react'
import ReactDOM from 'react-dom'
import ComingSoon from './components/ComingSoon'
import './assets/scss/app.scss'

ReactDOM.render(
        <ComingSoon />,
    document.querySelector("#root")
)